<template>
  <aside class="home-activity-notice" aria-label="首页活动通知">
    <button
      class="notice-close"
      type="button"
      data-track-text="关闭首页活动浮窗"
      aria-label="关闭首页活动浮窗"
      @click="$emit('close')"
    >
      <img src="@/assets/close.png" alt="">
    </button>
    <a
      v-if="notice.linkUrl"
      class="notice-link"
      :href="notice.linkUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img :src="notice.imageUrl" :alt="notice.title || '活动通知'">
    </a>
    <div v-else class="notice-link">
      <img :src="notice.imageUrl" :alt="notice.title || '活动通知'">
    </div>
  </aside>
</template>

<script>
export default {
  name: 'HomeActivityNotice',
  props: {
    notice: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.home-activity-notice {
  position: fixed;
  top: 150px;
  right: 10px;
  z-index: 100;
  width: min(411px, calc(100vw - 20px));
  box-sizing: border-box;
  border-radius: 6px;
  background: transparent;
}

.notice-close {
  width: 100%;
  height: 20px;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.notice-close img {
  width: 16px;
  height: 16px;
  display: block;
}

.notice-link {
  margin-left: 16px;
  display: block;
}

.notice-link img {
  width: 380px;
  max-width: calc(100% - 16px);
  height: auto;
  display: block;
}

@media (max-width: 900px) {
  .home-activity-notice {
    top: 72px;
  }
}
</style>
